export const COLORS = {
  text: "black",
  black: "#000000",
  primary: "rebeccapurple",
  darkGrey: "#141414",
  ligthGrey: "#1f1f1f",
  blue: "#177ddc",
  orange: "#ee8528",
  greyFontColor: "#dbdbdb",
  selectedColorTheme: "#177ddc",
};
